
import axios from 'axios';
import wx from 'weixin-js-sdk';
import $ from 'jquery';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import {promptMessage,fetch} from '@/api/dataHandling';
import dateFormat from 'vux/src/tools/date/format.js'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default {
data(){
return {
lookIf:true,
toastShow:false,
toastTxt:'',
openid:'',
submitdisabled:false,
otherzhengzhuangShow:false,
nozhengzhuangShow:false,
jiechudateShow:false,
hbjcsShow:false,
iconArry:{
xmIcon:false,
sexIcon:false,
ageIcon:false,
telIcon:false,
sfzhIcon:false,
jzdzQxIcon:false,
jzdzJdIcon:false,
jzdzSqIcon:false,
jzdzJtmphIcon:false,
zhengzhuangIcon:false,
hbfrryIcon:false,
jzggzbdryIcon:false,
hbljsIcon:false,
hbjcsIcon:false,
dqtwIcon:false,
zwbdhzIcon:false,
jjljcsIcon:false,
yqgjrjsIcon:false,
hzlxIcon:false,
},
zzQtzzSmIcon:false,
zzWsszzSmIcon:false,
hbljsFrsjIcon:false,
hbjcsJcsjIcon:false,
argge:true,
txrq:dateFormat(new Date(), 'YYYY-MM-DD'),
zhengzhuang:[],
hbljs:[],
hbfrry:[],
jzggzbdry:[],
hbjcs:[],
zwbdhz:[],
jjljcs:[],
yqgjrjs:[],

basedata:{
},
sexOptions:[{
key: '1',
value: '男'
}, {
key: '2',
value: '女'
}],
hzlxList:[
{key: '1', value: '患者'},
{key: '2', value: '其他'},
],
List:[
{key: '1', value: '是'},
{key: '2', value: '否'},
],
commonList: [
{key: 'zzFr', value: '发热(≥37.3°C)'},
{key: 'zzKs', value: '咳嗽'},
{key: 'zzSzt', value: '嗓子痛(咽痛)'},
{key: 'zzXm', value: '胸闷'},
{key: 'zzFxkn', value: '呼吸困难'},
{key: 'zzExot', value: '恶心呕吐'},
{key: 'zzFx', value: '腹泻'},
{key: 'zzQtzz', value: '其他症状'},
{key: 'zzWsszz', value: '无上述症状'}],
}
},
components:{
dateFormat ,CheckIcon,Cell,Checker, CheckerItem,Checklist,Toast,Icon,Grid, GridItem, GroupTitle,PopupPicker,Flexbox, FlexboxItem,Datetime,XTextarea,XInput,XHeader,Radio ,XButton,Group, PopupRadio
},
methods:{
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
},
tiwenyanzheng(){
if(this.basedata.dqtw >=35 &&  this.basedata.dqtw<=42){
this.iconArry.dqtwIcon = false;
}else{
this.basedata.dqtw ='';
this.IconClick('体温数值有误，请重新输入！');
this.iconArry.dqtwIcon = true;
}

},
xiaoshudianchange(){
this.$nextTick(function() {
this.basedata.dqtw = this.basedata.dqtw.replace(/[^\d.]/g, "");

this.basedata.dqtw = this.basedata.dqtw.replace(/^\./g, "");

this.basedata.dqtw = this.basedata.dqtw.replace(/\.{2,}/g, ".");

this.basedata.dqtw = this.basedata.dqtw.replace(".","$#$").replace(/\./g, "").replace("$#$", ".");

this.basedata.dqtw = this.basedata.dqtw.replace(/^(\-)*(\d+)\.(\d).*$/,'$1$2.$3');

let dqtw1 = this.basedata.dqtw.slice(0,1);
if(dqtw1 <3 || dqtw1 >4){
this.basedata.dqtw = '';
}

});

},

getmsg(){
fetch('post',urlConfig.healthReportingGet + this.openid).then(response => {
let datastring = JSON.stringify(response);
this.basedata = JSON.parse(datastring);
for(let i in this.basedata){
if(this.basedata[i] === null){
this.basedata[i] = '';
}
}

this.basedata.age = this.basedata.age.toString();
this.basedata.dqtw = this.basedata.dqtw.toString();
for(let i in this.basedata){
for(let j =0;j<this.commonList.length;j++){
if(i == this.commonList[j].key){
if(this.basedata[i] == 1){
this.zhengzhuang.push(i);
}
}
}
}
this.hbljs = this.basedata.hbljs.split(',');
this.hbfrry = this.basedata.hbfrry.split(',');
this.jzggzbdry = this.basedata.jzggzbdry.split(',');
this.hbjcs = this.basedata.hbjcs.split(',');
this.hzlx=this.basedata.hzlx.split(',');

this.zwbdhz = this.basedata.zwbdhz.split(',');
this.jjljcs = this.basedata.jjljcs.split(',');
this.yqgjrjs =this.basedata.yqgjrjs.split(',');

this.getmsg = JSON.parse(datastring);
for(let i in this.getmsg){
if(this.getmsg[i] === null){
this.getmsg[i] = '';
}
}

console.log(this.basedata,4444);
if(this.basedata.id){
this.lookIf = false;
}

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
console.log(error);
})
},
getopenid(code){
let cutton = 'http://front.wh.jinxin-fertility.com/pregnancyRegistration';
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;
window.localStorage.setItem('openid',this.openid);
getken(this.getmsg);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.lookIf = false;
});
},
requiredMethod(){
for(let i=0;i<arguments.length;i++){
if(arguments[i][2]){
if(!arguments[i][0].trim()){
this.iconArry[arguments[i][1]]= true;

}else{
this.iconArry[arguments[i][1]]= false;

}

}else {
if(!arguments[i][0].trim()){
this[arguments[i][1]]= true;
}else{
this[arguments[i][1]]= false;
}

}

}

}, //是否必填
iftrim(){
this.requiredMethod(
[this.basedata.xm,'xmIcon',true],


[this.basedata.tel,'telIcon',true],
[this.basedata.sfzh,'sfzhIcon',true],




[this.zhengzhuang.toString(),'zhengzhuangIcon',true],
[this.basedata.hbfrry,'hbfrryIcon',true],
[this.basedata.jzggzbdry,'jzggzbdryIcon',true],
[this.basedata.hbljs,'hbljsIcon',true],

[this.basedata.dqtw,'dqtwIcon',true],

[this.basedata.hbljsFrsj,'hbljsFrsjIcon',false],

[this.basedata.zwbdhz,'zwbdhzIcon',true],


[this.basedata.hzlx,'hzlxIcon',true],
);

}, // 判断是否为空
IconClick(text){
this.toastShow = true;
this.toastTxt = text;
},
SFZvalidate(){
let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.basedata.sfzh = this.basedata.sfzh.trim().replace(patrn, "")
if(!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.basedata.sfzh))){
this.iconArry.sfzhIcon = true;
if(!this.basedata.sfzh){
return false;
}
this.IconClick('证件号码不正确，请核实！');

}else{
this.iconArry.sfzhIcon = false;
}
})
},//验证身份证
telvaite(){
this.basedata.tel = this.basedata.tel.trim();
if(this.basedata.tel){
let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.basedata.tel = this.basedata.tel.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.basedata.tel) && this.basedata.tel){
this.iconArry.telIcon = false;
}else{
this.iconArry.telIcon = true;
this.toastShow = true;
this.toastTxt = '电话号码不正确，请核实！';

}
})
}

},
getArrDifference(arr1, arr2) {

return arr1.concat(arr2).filter(function(v, i, arr) {

return arr.indexOf(v) === arr.lastIndexOf(v);

});

},  //不同
getArrEqual(arr1, arr2) {
let newArr = [];
for (let i = 0; i < arr2.length; i++) {
for (let j = 0; j < arr1.length; j++) {
if(arr1[j] === arr2[i]){
newArr.push(arr1[j]);
}
}
}
return newArr;
},  //相同
zzQtzzSmChange(){
if(this.basedata.zzQtzzSm){
this.zzQtzzSmIcon = false;
}else{
this.zzQtzzSmIcon = true;
}
},
zhengzhuangChange(){
if(this.zhengzhuang.indexOf('zzQtzz') == -1){   // 没有包含其他症状
this.otherzhengzhuangShow = false;
this.basedata.zzQtzzSm = '';
}
if(this.zhengzhuang.indexOf('zzWsszzSm') == -1){  // 没有包含上诉症状
this.nozhengzhuangShow = false;
this.basedata.zzWsszzSm = '';
}
if(this.zhengzhuang.length !=0){
this.iconArry.zhengzhuangIcon = false;
let duibiarry = [];

for(let i=0;i<this.commonList.length;i++){
duibiarry.push(this.commonList[i].key)
}
let differenceArry = this.getArrDifference(this.zhengzhuang,duibiarry);  
let Equal = this.getArrEqual(this.zhengzhuang,duibiarry);
for(let i=0;i<differenceArry.length;i++){
this.basedata[differenceArry[i]] = '2';
}
for(let i=0;i<Equal.length;i++){
this.basedata[Equal[i]] = '1';
}

for(let i=0;i<this.zhengzhuang.length;i++){

if(this.zhengzhuang[i] == 'zzQtzz'){
this.otherzhengzhuangShow = true;
this.nozhengzhuangShow = false;
if(this.basedata.zzQtzzSm){
this.zzQtzzSmIcon = false;
}else{
this.zzQtzzSmIcon = true;
}
}else if(this.zhengzhuang[i] == 'zzWsszz'){
this.nozhengzhuangShow = true;
this.zhengzhuang = ['zzWsszz'];

}
}
}else{
this.iconArry.zhengzhuangIcon = true;
}



}, // 选择症状
Listchange(obj){

if(this[obj].length){
this.basedata[obj] = this[obj].toString();
this.iconArry[obj+'Icon'] = false;
}else{
this.iconArry[obj+'Icon'] = true;
}

},
zljsChange(){
if(this.hbljs.length){
this.basedata.hbljs = this.hbljs.toString();
if(this.lookIf){
this.basedata.hbljsFrsj ='';
}

this.iconArry.hbljsIcon = false;
if(this.hbljs.toString() == 1){
this.jiechudateShow = true;
}else {
this.jiechudateShow = false;
}
}else{
this.iconArry.hbljsIcon = true;
}

},   //地区接触史
hbjcsChange(){
if(this.hbjcs.length){
this.basedata.hbjcs = this.hbjcs.toString();
if(this.lookIf){
this.basedata.hbjcsJcsj ='';
}
this.iconArry.hbjcsIcon = false;
if(this.hbjcs.toString() == 1) {
this.hbjcsShow = true;
} else {
this.hbjcsShow = false;
}
}else{
this.iconArry.hbjcsIcon = true;
}
}, //人员接触史
sumbitmethod(){
console.log(this.basedata,'提交');
fetch('post',urlConfig.healthReportingSave,this.basedata).then(response => {
promptMessage('提示','提交成功', function () {
window.location.reload();
});

}).catch(error => {

})
},
sureClick(){
this.iftrim();
this.basedata.qm = this.basedata.xm;
this.basedata.txrq = this.txrq;
let chencknum = 0;  
let iconArryLength = 0;  
for(let i in this.iconArry){

iconArryLength++;
if(!this.iconArry[i]){

chencknum++;
}
}

if(this.argge){

if(chencknum == iconArryLength){
if(this.basedata.hbljs == 1){
if(this.hbljsFrsjIcon){
this.IconClick('请填写返蓉时间！');
return false;
}
}
if(this.basedata.hbjcs == 1){
if(this.hbjcsJcsjIcon){
this.IconClick('请填写最后接触时间！');
return false;
}
}
for(let i=0;i<this.zhengzhuang.length;i++){

if(this.zhengzhuang[i] == 'zzQtzz' && this.zzQtzzSmIcon){
$("body ,html").scrollTop($('#one').position().top);
this.IconClick('请填写其他症状说明！');
return false;
}
}
this.sumbitmethod();
}else{
this.IconClick('还有选项未填写');
if(this.iconArry.zhengzhuangIcon || this.iconArry.hbfrryIcon){
$("body ,html").scrollTop($('#one').position().top);
}else if(this.iconArry.jzggzbdryIcon || this.iconArry.hbljsIcon || this.iconArry.hbljsIcon || this.iconArry.dqtwIcon){
$("body ,html").scrollTop($('#two').position().top);
}else{
$("body ,html").scrollTop(0);
}

}
console.log(this.basedata)
}else{
promptMessage('提示','请选择我已阅读！')
}


},
},
mounted(){
/*   getken(this.getmsg);*/
var _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
if(window.localStorage.getItem('openid')){
_this.openid = window.localStorage.getItem('openid');
getken(this.getmsg);
}else{
_this.getopenid(_this.$route.query.code)
}

}

wx.config({
debug: false,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
appId: _this.weixindata.appId,
jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems']
});
}).catch(function (error) {
promptMessage('提示' +error)

});
this.$nextTick(function(){
$('.inputClick').on('click',function(){
if(_this.lookIf){
$(this).find('input, .textarea').focus();
}

})
})
}
}



// WEBPACK FOOTER //
// ./src/project/activitiesProject/healthReporting.vue